import React, {Fragment, useState} from "react";
import {Button, Col, Container, FormGroup, Label, Media, Row} from "reactstrap";
import localized from "../../i18n";
import {Link, useNavigate} from "react-router-dom";
import {Formik} from "formik";
import Field from "../Field";
import {strongPassword} from "../Field/validate";
import axios from "axios";
import {handleError, showsuccesToast} from "../HandleError";

const getParams = function (key = "") {
    const url = window.location.search;
    let match = url.match('[?&]' + key + '=([^&]+)');
    return match ? match[1] : null;
}

const NewPasswordPage = () => {
    const naviagate = useNavigate();
    const [showPassword,setShowPassword] = useState({
        newPassword:false,
        confirmPassword:false,
    });

    const togglePassword = (field = "newPassword") => {
        setShowPassword((prev)=>({
            ...prev,[field]:!showPassword[field]
        }))
    }

    const newPassword = (values, setSubmitting) => {
        setSubmitting(true);
        const data = {...values};
        data.token = getParams("token");
        data.email = getParams("email");

        axios.post("/api/reset-password", data)
            .then((response) => {
                setSubmitting(false);
                naviagate("/login");
                showsuccesToast(localized.password_updated_successfully);
            }).catch((err) => {
            handleError(err);
            setSubmitting(false);
        })
    }

    return (
        <Container fluid={true} className="p-0">
            <Row className="m-0">
                <Col xs="12" className="p-0">
                    <div className="login-card auth-login">
                        <div>
                            <div className="logo">
                                <Media
                                    className={"img-fluid for-light w-50"}
                                    src={`${require("../../assets/images/logo/logo.png")}`}
                                    alt={"logo image"}
                                />
                            </div>
                            <div className="login-main login-tab">
                                <Formik
                                    initialValues={{
                                        new_password: "",
                                        confirm_password: "",
                                    }}
                                    onSubmit={(values, {setSubmitting}) => newPassword(values, setSubmitting)}
                                >
                                    {props => {
                                        const {handleSubmit, isSubmitting} = props;
                                        return (
                                            <form onSubmit={handleSubmit} className="theme-form">
                                                <Fragment>
                                                    <h2 className={"text-center"}> {localized.user_new_password} </h2>
                                                    <p className={"text-center"}>
                                                        {localized.new_password_description}
                                                    </p>
                                                </Fragment>
                                                <FormGroup>
                                                    <Label for="examplePassword">New Password</Label>
                                                    <div className="position-relative">
                                                        <Field
                                                            name="new_password"
                                                            type={showPassword.newPassword ? "text" : "password"}
                                                            validate={strongPassword}
                                                        />
                                                        <div className="show-hide" onClick={() => togglePassword("newPassword")}>
                                                            <span className={showPassword.newPassword ? "" : "show"}/>
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label for="examplePassword">Confirm Password</Label>
                                                    <div className="position-relative">
                                                        <Field
                                                            name="confirm_password"
                                                            type={showPassword.confirmPassword ? "text" : "password"}
                                                            validate={strongPassword}
                                                        />
                                                        <div className="show-hide" onClick={() => togglePassword("confirmPassword")}>
                                                            <span className={showPassword.confirmPassword ? "" : "show"}/>
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                                <div className="text-end mt-3">
                                                    <Button
                                                        type="submit"
                                                        color={"primary w-100"}
                                                        className={"btn-block"}
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? "Submitting..." : localized.submit}
                                                    </Button>
                                                </div>
                                            </form>
                                        )
                                    }}
                                </Formik>
                                <p className="mt-4 mb-0 text-center">
                                    Already have an account?
                                    <Link className="ms-2" to="/login">
                                        {localized.SignIn}
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
export default NewPasswordPage;